'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var setUserTrialCount = 3;

var setUser = exports.setUser = function setUser(user) {
  if (!window.Raven) {
    if (setUserTrialCount) {
      setUserTrialCount--;
      return setTimeout(setUser, 1000, user);
    }

    return console.error('sentry is not found!');
  }

  Raven.setUserContext(user);

  console.debug('set sentry user success!');
};